export default __webpack_public_path__ + "static/5-d5ed94c27ae95b1cab032eed3aea69cd.png";